"use client";

import Image from "next/image";
import { useState, useRef, useEffect } from "react";

import {PostImageProps} from "@/types/img"

const DEFAULT_PLACEHOLDER =
    `${process.env.NEXT_PUBLIC_STORAGE_UPLOADS_ASSETS_IMG ?? ""}/lazy/load-post.webp`;

export function PostImage({
                              src,
                              alt,
                              priority = false,
                              w = 250,
                              h = 150,
                              className = "object-cover w-full h-full rounded-lg",
                              PLACEHOLDER = DEFAULT_PLACEHOLDER,
                          }: PostImageProps) {
    const imgRef = useRef<HTMLImageElement>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (imgRef.current?.complete) {
            setIsLoading(false);
        }
    }, [src]);

    return (
        <div className="relative overflow-hidden rounded-lg h-full">
            {isLoading && (
                <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-100 animate-pulse">
                    <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
                </div>
            )}
            <Image
                ref={imgRef}
                src={src}
                alt={alt}
                width={w}
                height={h}
                priority={priority}
                loading={priority ? "eager" : "lazy"}
                fetchPriority={priority ? "high" : "auto"}
                placeholder="blur"
                blurDataURL={PLACEHOLDER}
                className={`transition-opacity duration-300 ${isLoading ? "opacity-0" : "opacity-100"}  ${className} `}
                unoptimized
                onLoad={() => setIsLoading(false)}
            />
        </div>
    );
}